import { JSX } from "react";
import { QESButtonTypes } from "@app/shared/qes-standards/Button";

export interface ModalContent {
    body: JSX.Element | string;
    cancelButtonText: string;
    cancelButtonType?: CancelButtonType
    confirmButtonAction: () => void;
    confirmButtonDisable?: boolean;
    confirmButtonText: string;
    confirmButtonType?: QESButtonTypes;
    title: string;
}

export enum CancelButtonType {
  Default,
  TopRight
}